import { createContext, useContext } from 'react';

export interface IFilterSortContext {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: any
  onFilterDrawerHandler:()=>void
  openFilterDrawer:boolean
  sortOpened:boolean
  setSortOpened:(value:boolean)=>void
  findFilter:string
  sort:string
  createSortObj:(sorts: string[])=>string | null
  userFilters?: string | null;
  userSorts?: string | null;
  isDataReady: boolean;
  submit: boolean;
}

export const FilterSortContext = createContext({} as IFilterSortContext);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useFilterSortContext = () => useContext(FilterSortContext);
